/**
 * Shipments Redux Selectors
 */

import { createSelector } from '@reduxjs/toolkit'
import type { ShipmentsState } from './shipments.slice'

interface RootState { shipments: ShipmentsState }

export const selectShipmentsState = (state: RootState) => state.shipments
export const selectShipments = (state: RootState) => state.shipments.items
export const selectSelectedShipment = (state: RootState) => state.shipments.selectedShipment
export const selectShipmentStats = (state: RootState) => state.shipments.stats
export const selectShipmentsFilter = (state: RootState) => state.shipments.filter
export const selectShipmentsPagination = (state: RootState) => state.shipments.pagination
export const selectShipmentsLoading = (state: RootState) => state.shipments.loading
export const selectShipmentsError = (state: RootState) => state.shipments.error

// Note: Filtering is now done server-side via pagination API
// This selector returns the items as-is (already filtered by the API)
export const selectFilteredShipments = createSelector(
  [selectShipments],
  (shipments) => shipments
)

export const selectLoadingShipments = createSelector(
  [selectShipments],
  shipments => shipments.filter(s => s.status === 'loading')
)
